/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPaymentsQueryResponse, GetApiPaymentsQueryParams, GetApiPayments400, GetApiPayments403, GetApiPayments404, GetApiPayments500 } from "../entities/GetApiPayments";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiPayments } from "../api/getApiPayments";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiPaymentsQueryKey = (params: GetApiPaymentsQueryParams) => [{ url: '/api/payments' }, ...(params ? [params] : [])] as const

export type GetApiPaymentsQueryKey = ReturnType<typeof getApiPaymentsQueryKey>

export function getApiPaymentsQueryOptions(params: GetApiPaymentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiPaymentsQueryKey(params)
        return queryOptions<GetApiPaymentsQueryResponse, ResponseErrorConfig<GetApiPayments400 | GetApiPayments403 | GetApiPayments404 | GetApiPayments500>, GetApiPaymentsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiPayments(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Возвращает текущий статус последнего платежа группы записей
 * @summary Получить статус оплаты
 * {@link /api/payments}
 */
export function useGetApiPayments<TData = GetApiPaymentsQueryResponse, TQueryData = GetApiPaymentsQueryResponse, TQueryKey extends QueryKey = GetApiPaymentsQueryKey>(params: GetApiPaymentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiPaymentsQueryResponse, ResponseErrorConfig<GetApiPayments400 | GetApiPayments403 | GetApiPayments404 | GetApiPayments500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiPaymentsQueryKey(params)
         

         const query = useQuery({
          ...getApiPaymentsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetApiPayments400 | GetApiPayments403 | GetApiPayments404 | GetApiPayments500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}